import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  width: 100%;
  display: flex;
  flex-direction: column;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;

  padding: 24px;
  box-sizing: border-box;

  gap: 8px;

  .input-sequence-name {
    max-width: 720px;
    flex: 1;
  }
`

export const SequenceTemplatePlanningContainer = styled.div`
  height: calc(100vh - 53px - 112px);
`
